import { useState } from "react";
import { GrButton, GrMenu, GrMenuProps } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";

export type UploadDropdownButtonProps = {
  menuOptions: Pick<GrMenuProps, "position" | "size" | "items">;
  buttonText?: string;
  disabled?: boolean;
};

export function UploadDropdownButton({
  menuOptions,
  buttonText = MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_COMMON_ADD_NOUN),
  disabled,
}: UploadDropdownButtonProps) {
  const { items, position, size } = menuOptions;
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

  return (
    <>
      <GrButton
        startIcon="plus"
        disabled={disabled}
        endIcon={anchorElement ? "chevron-up" : "chevron-down"}
        onClick={(e) => setAnchorElement(e.currentTarget)}
        style={{ minWidth: "max-content" }}
      >
        {buttonText}
      </GrButton>
      <GrMenu items={items} onClose={() => setAnchorElement(null)} position={position} size={size} anchorElement={anchorElement} />
    </>
  );
}
